import React, { useState, useEffect, useRef } from 'react';

var squareViewBox = 245;
const Arc = (props) =>
    <svg className="clock__arc-svg" width={squareViewBox} height={squareViewBox} viewBox={`0 0 ${squareViewBox} ${squareViewBox}`} xmlns="http://www.w3.org/2000/svg" >
        <g transform={`rotate(${props.rotAngle},${squareViewBox / 2},${squareViewBox / 2})`}>
            <circle className="arc-base" cx="50%" cy="50%" r={props.r} strokeDasharray={props.strokeDasharrayBase} stroke="#EEE" strokeWidth="7px"></circle>
            <circle className="arc-peak" cx="50%" cy="50%" r={props.r} strokeDasharray={props.strokeDasharrayArc} stroke="#3cb449" strokeWidth="7px"></circle>
        </g>
        <text className="clock__arc-svg-label" x="50%" y="67%" dominantBaseline="middle" textAnchor="middle">Occupancy</text>
    </svg>


const Needle = (props) => {
    const [haveTrans, setHaveTrans] = useState(false)
    useEffect(() => {
        window.addEventListener("resize", setHaveTrans(false));
        return () => {
            window.removeEventListener("resize", setHaveTrans(false))
        }
    }, [])

    useEffect(() => {
        if (!haveTrans) {
            setHaveTrans(true);
        }
    }, [haveTrans, props.rotate])

    return (
        <svg className="clock__arc-needle" width={squareViewBox} height={squareViewBox} viewBox={`0 0 ${squareViewBox} ${squareViewBox}`} >
            <defs>
                <filter id="glow-gray">
                    <feOffset in="SourceAlpha" dx="-0.1" dy="0.1" result="offOut" />
                    <feGaussianBlur in="offOut" stdDeviation="1" result="blurOut" />
                    <feComponentTransfer>
                        <feFuncA type="linear" slope="0.5" />
                    </feComponentTransfer>
                    <feMerge>
                        <feMergeNode />
                        <feMergeNode in="SourceGraphic" />
                    </feMerge>
                </filter>
            </defs>
            <g transform={props.rotate} className={haveTrans ? "have-trans" : ""}>
                <g filter="url(#glow-gray)">
                    <line stroke="#3f5043" strokeWidth="2" x1={squareViewBox / 2} y1={squareViewBox / 2} x2={squareViewBox / 1.32} y2={squareViewBox / 2}></line>
                    <circle cx={squareViewBox / 2} cy={squareViewBox / 2} r="9.360000000000001" fill="#3f5043"></circle>
                </g>
            </g>
        </svg>
    );
}


const Info = (props) =>
    <React.Fragment>
        <p className="clock__info-label clock__info-label_left">
            <b className="font--proLight">{props.avgPercent}</b>
            <span className="small-label">% Avg</span>
        </p>
        <p className="clock__info-label clock__info-label_right clock__info-label_text_green">
            <span className="small-label">Peak </span>
            <b className="font--proLight">{props.peakPercent}</b><span className="small-label" >%</span>
        </p>
    </React.Fragment>

const Marker = (props) =>
    <p style={props.css}>
        {/* <span style={{ display: "none" }} className="percent">{props.markerValue}</span><br></br>
            */}
        <span className="ticks bold">|</span>
    </p>


export default function Gauge(props) {
    const [clockCss, setCss] = useState({});
    const myClockRef = useRef(null);
    useEffect(() => {
        window.addEventListener("resize", updateWidth());
        return () => {

            window.removeEventListener("resize", updateWidth());
        }
    }, [])

    function updateWidth() {
        var width = myClockRef.current.offsetWidth;
        var scaleNum = (width / squareViewBox);
        var scale = "scale(" + scaleNum + ")";
        var height = 200 * scaleNum;
        var clockCss = {
            transformOrigin: 'left top',
            WebkitTransformOrigin: 'left top',
            transform: scale,
            WebkitTransform: scale,
            fontSize: "14px",
            height: `${height}px`
        }
        setCss(clockCss);
    }

    function renderArc() {
        var cf, fullDashLen, arcDashLen, r, arcAngle, rotAngle, peakValue;
        peakValue = props.values[1]; //peak
        r = props.arcParams[0];
        arcAngle = props.arcParams[1];
        cf = 2 * r * Math.PI;
        fullDashLen = cf * ((360 - arcAngle) / 360);
        arcDashLen = fullDashLen * peakValue;
        rotAngle = (180 - arcAngle) / 2 + arcAngle;
        var strokeDasharrayArc = [arcDashLen, cf];
        var strokeDasharrayBase = [fullDashLen, cf];
        return (
            <Arc
                r={r}
                strokeDasharrayArc={strokeDasharrayArc}
                strokeDasharrayBase={strokeDasharrayBase}
                rotAngle={rotAngle}
            />
        );
    }

    function renderNeedle() {
        var arcAngle, avgValue;
        avgValue = props.values[0];
        arcAngle = props.arcParams[1];
        var offset = (180 - arcAngle) / 2 + arcAngle;
        var needleAngle = offset + (360 - arcAngle) * avgValue;
        var rotate = `rotate( ${needleAngle},${squareViewBox / 2},${squareViewBox / 2})`;
        return (
            <Needle
                rotate={rotate}
            />
        );
    }

    function renderInfo() {
        var avgPercent = Math.round(props.values[0] * 100);
        var peakPercent = Math.round(props.values[1] * 100);
        return (
            <Info
                avgPercent={avgPercent}
                peakPercent={peakPercent}
            />
        );
    }

    function renderMarkers() {
        var markerValue, markerAngle, arcAngle, count;
        var returnArray = [];
        var css = {};
        var rotate = "";
        var offset = 2;
        arcAngle = props.arcParams[1];
        count = 5;
        for (var i = 0; i < count; i++) {
            markerValue = 0 + i * 100 / (count - 1);
            markerAngle = -(362 - arcAngle - offset) / 2 + i * (362 - arcAngle - offset) / (count - 1);
            rotate = "rotate(" + markerAngle + "deg)";
            css = {
                WebkitTransform: rotate,
                transform: rotate
            }
            returnArray[i] = <Marker key={i} markerValue={markerValue} css={css} />;
        }
        return returnArray;
    }

    return (
        <div className="clock" ref={myClockRef} style={clockCss}>
            <div className="clock__markers" style={{ width: `${squareViewBox}px`, height: `${squareViewBox}px` }}>
                {renderMarkers()}
            </div>
            <div className="clock__info">
                {renderInfo()}
            </div>
            <div className="clock__arc">
                {renderArc()}
                {renderNeedle()}
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/common/widgets/gauge.jsx